module.exports = __webpack_public_path__ + "static/media/terrain-water-01.4b83e011.svg";